import { Link } from "react-router-dom";
import sgbudget2024Logo from "@assets/logo-budget2024-v3.svg";
import { sectionNavigationItems } from "@util/constant";

export default function SGBudget2024(): React.ReactElement {
  return (
    <div className="-mx-3 -mt-6 mb-6 flex items-center justify-between gap-4 border-b border-gray-850 bg-gray-250 px-2 py-4 sm:px-4 md:mt-0 lg:mx-0">
      <div className="flex items-center">
        <img
          src={sgbudget2024Logo}
          width={40}
          height={56}
          alt="Singapore Budget 2024"
        />
        <h3 className="ml-2 border-l border-gray-850 border-opacity-20 py-2 pl-2 font-poppins text-xs font-normal lg:text-xl">
          Singapore Budget 2024
        </h3>
      </div>

      {sectionNavigationItems["keywords/singapore-budget-2024"] ? (
        <Link
          to={`${sectionNavigationItems["keywords/singapore-budget-2024"].link}?ref=banner`}
          target="_blank"
          className="whitespace-nowrap rounded-full border border-gray-850 bg-gray-850 px-5 py-2 font-poppins text-4xs font-semibold text-white lg:px-12 lg:text-base"
        >
          READ MORE
        </Link>
      ) : null}
    </div>
  );
}
